module.exports = __webpack_public_path__ + "img/bg_figure6.c17153ba.png";